import {
  Clock, CheckCircle, DollarSign, Home, ThumbsUp,
  ShieldCheck, ScanLine, Calendar, Users, Ruler,
  CalendarClock, Hammer,Brush, Wrench
} from 'lucide-react';

export const iconMap = {
  Home: <Home className="w-8 h-8 text-primary" />,
  ScanLine: <ScanLine className="w-8 h-8 text-primary" />,
  Clock: <Clock className="w-8 h-8 text-primary" />,
  ShieldCheck: <ShieldCheck className="w-8 h-8 text-primary" />,
  Calendar: <Calendar className="w-8 h-8 text-primary" />,
  CheckCircle: <CheckCircle className="w-8 h-8 text-primary" />,
  ThumbsUp: <ThumbsUp className="w-8 h-8 text-primary" />,
  DollarSign: <DollarSign className="w-8 h-8 text-primary" />,
  Users: <Users className="w-10 h-10 text-primary" />,
  Ruler: <Ruler className="w-10 h-10 text-primary" />,
  CalendarClock: <CalendarClock className="w-10 h-10 text-primary" />,
  Hammer: <Hammer className="w-10 h-10 text-primary" />,
  Brush: <Brush className="w-10 h-10 text-primary" />,
  Wrench: <Wrench className="w-10 h-10 text-primary" />,  
};
